export const about = {
  hero: {
    title: 'About BridgeCore empowermennt initiative',
    subtitle: 'Bridgecore Empowerment Initiative is a refugee-led organization and a beacon of hope for refugees and vulnerable communities. Founded by individuals with lived experience of displacement, we are committed to restoring dignity, promoting safety, and creating opportunities for people to rebuild their lives with purpose and resilience. We believe everyone deserves not just support, but the opportunity to thrive and shape their own future.',
    stats: {
      yearsOfService: 'Years of Service',
      livesImpacted: 'Lives Impacted',
      activeProjects: 'Active Projects',
      teamMembers: 'Team Members',
    },
  },
  mission: {
    badge: 'Our Mission',
    text: 'To equip refugees, youth, and women with digital and vocational skills, provide access to opportunities, and support sustainable livelihoods through empowerment programs.',
    teamMembers: 'Dedicated Team Members',
    volunteers: 'Active Volunteers',
    visionTitle: 'Our Vision',
    visionText: 'A future where refugees and vulnerable communities are empowered with skills, self-reliant, and connected to sustainable opportunities.',
    valuesTitle: 'Our Values',
    values: {
      compassion: 'Compassion & Dignity',
      transparency: 'Transparency & Accountability',
      empowerment: 'Community Empowerment',
    },
  },
  coreValues: {
    title: 'Our Core Values',
    subtitle: 'The principles that guide our mission and impact',
    values: {
      dignity: {
        title: 'Dignity and Respect',
        description: 'We uphold the inherent worth of every individual, treating all people with fairness, compassion, and respect.',
      },
      empowerment: {
        title: 'Empowerment',
        description: 'We equip individuals with skills, knowledge, and opportunities to become self-reliant and confident.',
      },
      inclusivity: {
        title: 'Inclusivity',
        description: 'We embrace diversity and ensure equal access to opportunities for refugees, youth, women, and marginalized communities.',
      },
      integrity: {
        title: 'Integrity',
        description: 'We act with honesty, transparency, and accountability in all our actions and partnerships.',
      },
      resilience: {
        title: 'Resilience',
        description: 'We foster strength and perseverance, helping communities overcome challenges and rebuild their lives.',
      },
      collaboration: {
        title: 'Collaboration',
        description: 'We believe in the power of partnerships and teamwork to create sustainable impact.',
      },
      innovation: {
        title: 'Innovation',
        description: 'We encourage creative solutions and use technology to drive positive change.',
      },
    },
  },
  team: {
    title: 'Meet Our Leadership Team',
    subtitle: 'Dedicated professionals committed to making a lasting impact in the lives of refugees and vulnerable communities.',
  },
  partners: {
    title: 'Our Partners',
    subtitle: 'Working together with international organizations and local communities to maximize our impact and reach.',
    partnerWithUs: {
      title: 'Partner With Us',
      description: 'Join a network of organizations committed to creating lasting change. Whether through sponsorship, strategic partnerships, or collaborative programs, your support can transform lives and empower communities to thrive.',
      benefits: [
        'Make a meaningful impact in refugee communities',
        'Connect with a global network of humanitarian organizations',
        'Access collaborative funding opportunities',
        'Showcase your commitment to social responsibility',
      ],
      cta: 'Become a Partner',
    },
    achievementsTitle: 'Key Achievements',
    achievementsSubtitle: 'Milestones that showcase our commitment and impact',
    awards: {
      humanitarian: {
        title: '',
        description: 'Recognized for outstanding service to refugee communities',
      },
      certified: {
        title: '',
        description: 'Fully accredited by international humanitarian standards',
      },
      rating: {
        title: '',
        description: 'Top-rated for transparency and impact effectiveness',
      },
    },
  },
  volunteer: {
    title: 'Become a Volunteer',
    subtitle: 'Join our team and make a direct impact in the lives of refugees and vulnerable communities.',
  },
};